const locale = {
  TITLE_CONNECTION_ISSUE: '¡Ups! Algo salió mal',
  SUBTITLE_CONNECTION_ISSUE:
    'Parece que estamos teniendo problemas de conexión. Por favor, inténtalo de nuevo más tarde.',
  HOME_BUTTON_CONNECTION_ISSUE: 'Volver al inicio',
};

export default locale;
